<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
        <h3 class="p-2">
            <small class="text-muted">Space Analysis Detail</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div v-if="this.$route.query.id === undefined" class="form-group col-3">
                <label for="module">Patient Name</label>
                <app-lookup-field :model="patientOrthoSpace" :element="patientLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div>
            <div v-if="this.$route.query.id !== undefined" class="form-group col-3">
                <label>Patient Name</label>
                <input type="text" class="form-control" v-model="patientOrthoSpace.patientName" disabled id="patientName" aria-describedby="action">
            </div>
            <div class="form-group col-2">
                <label for="module">Patient Age</label>
                <input type="text" class="form-control" v-model="patientOrthoSpace.patientAge" disabled id="patientName" aria-describedby="action">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <label for="module">Patient Address</label>
                <textarea class="form-control" id="desc-textarea" v-model="patientOrthoSpace.patientAddress" rows="2" disabled></textarea>
            </div>
        </div>
        <div class="p-2 dropdown-divider" style="border-top: 2px solid black;"></div>
        <div class="form-inline" id="centercontent">
            <label>RA</label>
            <div class="input-group mb-2 mr-sm-2">
                <input type="number" class="form-control" id="ra" v-model="patientOrthoSpace.ra">
                <div class="input-group-prepend">
                    <div class="input-group-text">mm</div>
                </div>
            </div>
        </div>
        <br />
        <div class="row">
            <div class="form-group col-2">
                <label>Pergeseran Median Line</label>
            </div>
            <div class="input-group col-2"> 
            </div>
            <div class="form-group col-2">
                <div class="input-group mb-2 mr-sm-2">
                    <input type="number" class="form-control" id="medianLineTL" v-model="patientOrthoSpace.medianLineTL">
                    <div class="input-group-prepend">
                        <div class="input-group-text">mm</div>
                    </div>
                </div>
            </div>
            <div class="input-group col-2"> 
            </div>
             <div class="form-group col-2">
                <div class="input-group mb-2 mr-sm-2">
                    <input type="number" class="form-control" id="medianLineTR" v-model="patientOrthoSpace.medianLineTR">
                    <div class="input-group-prepend">
                        <div class="input-group-text">mm</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-2">
                <label>Kekurangan tempat</label>
            </div>
            <div class="input-group col-2"> 
            </div>
            <div class="form-group col-2">
                <div class="input-group mb-2 mr-sm-2">
                    <input type="number" class="form-control" id="lackOfSpaceTL" v-model="patientOrthoSpace.lackOfSpaceTL">
                    <div class="input-group-prepend">
                        <div class="input-group-text">mm</div>
                    </div>
                </div>
            </div>
            <div class="input-group col-1" style="border-right: 2px solid black;"> 
            </div>
            <div class="input-group col-1"> 
            </div>
             <div class="form-group col-2">
                <div class="input-group mb-2 mr-sm-2">
                    <input type="number" class="form-control" id="lackOfSpaceTR" v-model="patientOrthoSpace.lackOfSpaceTR">
                    <div class="input-group-prepend">
                        <div class="input-group-text">mm</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-2">
                <label>Panjang Lengkung</label>
            </div>
            <div class="input-group col-2"> 
            </div>
            <div class="form-group col-2">
                <div class="input-group mb-2 mr-sm-2">
                    <input type="number" class="form-control" id="bendLengthTL" v-model="patientOrthoSpace.bendLengthTL">
                    <div class="input-group-prepend">
                        <div class="input-group-text">mm</div>
                    </div>
                </div>
            </div>
            <div class="input-group col-1" style="border-right: 2px solid black;"> 
            </div>
            <div class="input-group col-1"> 
            </div>
             <div class="form-group col-2">
                <div class="input-group mb-2 mr-sm-2">
                    <input type="number" class="form-control" id="bendLengthTR" v-model="patientOrthoSpace.bendLengthTR">
                    <div class="input-group-prepend">
                        <div class="input-group-text">mm</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-2">
                <label>Jumlah Mesiodistal</label>
            </div>
            <div class="input-group col-2"> 
            </div>
            <div class="form-group col-2">
                <div class="input-group mb-2 mr-sm-2">
                    <input type="number" class="form-control" id="sumOfMesiodistalTL" v-model="patientOrthoSpace.sumOfMesiodistalTL">
                    <div class="input-group-prepend">
                        <div class="input-group-text">mm</div>
                    </div>
                </div>
            </div>
            <div class="input-group col-1" style="border-right: 2px solid black;"> 
            </div>
            <div class="input-group col-1"> 
            </div>
             <div class="form-group col-2">
                <div class="input-group mb-2 mr-sm-2">
                    <input type="number" class="form-control" id="sumOfMesiodistalTR" v-model="patientOrthoSpace.sumOfMesiodistalTR">
                    <div class="input-group-prepend">
                        <div class="input-group-text">mm</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-2">
                <label>Panjang Lengkung</label>
            </div>
            <div class="form-group col-2">
                <input type="number" class="form-control" id="bendLength1TL" aria-describedby="action" v-model="patientOrthoSpace.bendLength1TL">
            </div>
            <div class="form-group col-2">
                <input type="number" class="form-control" id="bendLength2TL" aria-describedby="action" v-model="patientOrthoSpace.bendLength2TL">
            </div>
            <div class="input-group col-1" style="border-right: 2px solid black;"> 
            </div>
            <div class="input-group col-1"> 
            </div>
            <div class="form-group col-2">
                <input type="number" class="form-control" id="bendLength1TR" aria-describedby="action" v-model="patientOrthoSpace.bendLength1TR">
            </div>
            <div class="form-group col-2">
                <input type="number" class="form-control" id="bendLength2TR" aria-describedby="action" v-model="patientOrthoSpace.bendLength2TR">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-2">
                <label>Mesiodistal</label>
            </div>
            <div class="form-group col-2">
                <input type="number" class="form-control" id="mesiodistal1TL" aria-describedby="action" v-model="patientOrthoSpace.mesiodistal1TL">
            </div>
            <div class="form-group col-2">
                <input type="number" class="form-control" id="mesiodistal2TL" aria-describedby="action" v-model="patientOrthoSpace.mesiodistal2TL">
            </div>
            <div class="input-group col-1" style="border-right: 2px solid black;"> 
            </div>
            <div class="input-group col-1"> 
            </div>
            <div class="form-group col-2">
                <input type="number" class="form-control" id="mesiodistal1TR" aria-describedby="action" v-model="patientOrthoSpace.mesiodistal1TR">
            </div>
            <div class="form-group col-2">
                <input type="number" class="form-control" id="mesiodistal2TR" aria-describedby="action" v-model="patientOrthoSpace.mesiodistal2TR">
            </div>
        </div>

        <div class="row">
            <div class="form-group col-2">
                <label></label>
            </div>
            <div class="input-group col-5" style="border-right: 2px solid black;"> 
                <div class="form-group custom-textbox-left">
                    <input type="text" class="form-control" id="teeth1TL" aria-describedby="action" v-model="patientOrthoSpace.teeth1TL">
                </div>
                <div class="form-group custom-textbox-left">
                    <input type="text" class="form-control" id="teeth2TL" aria-describedby="action" v-model="patientOrthoSpace.teeth2TL">
                </div>
                <div class="form-group custom-textbox-left">
                    <input type="text" class="form-control" id="teeth3TL" aria-describedby="action" v-model="patientOrthoSpace.teeth3TL">
                </div>
                <div class="form-group custom-textbox-left">
                    <input type="text" class="form-control" id="teeth4TL" aria-describedby="action" v-model="patientOrthoSpace.teeth4TL">
                </div>
                <div class="form-group custom-textbox-left">
                    <input type="text" class="form-control" id="teeth5TL" aria-describedby="action" v-model="patientOrthoSpace.teeth5TL">
                </div>
                <div class="form-group custom-textbox-left">
                    <input type="text" class="form-control" id="teeth6TL" aria-describedby="action" v-model="patientOrthoSpace.teeth6TL">
                </div>
                <div class="form-group custom-textbox-left">
                    <input type="text" class="form-control" id="teeth7TL" aria-describedby="action" v-model="patientOrthoSpace.teeth7TL">
                </div>
                <div class="form-group custom-textbox-left">
                    <input type="text" class="form-control" id="teeth8TL" aria-describedby="action" v-model="patientOrthoSpace.teeth8TL">
                </div>
            </div>
            <div class="form-group col-1">
                <label></label>
            </div>
            <div class="input-group col-4"> 
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" id="teeth1TR" aria-describedby="action" v-model="patientOrthoSpace.teeth1TR">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" id="teeth2TR" aria-describedby="action" v-model="patientOrthoSpace.teeth2TR">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" id="teeth3TR" aria-describedby="action" v-model="patientOrthoSpace.teeth3TR">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" id="teeth4TR" aria-describedby="action" v-model="patientOrthoSpace.teeth4TR">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" id="teeth5TR" aria-describedby="action" v-model="patientOrthoSpace.teeth5TR">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" id="teeth6TR" aria-describedby="action" v-model="patientOrthoSpace.teeth6TR">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" id="teeth7TR" aria-describedby="action" v-model="patientOrthoSpace.teeth7TR">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" id="teeth8TR" aria-describedby="action" v-model="patientOrthoSpace.teeth8TR">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="form-group col-2" >
                <label></label>
            </div>
            <div class="input-group col-5" style="border-right: 2px solid black; border-bottom: 2px solid black;"> 
                <div class="form-group custom-textbox-left">
                    <input type="text" class="form-control" disabled value="8">
                </div>
                <div class="form-group custom-textbox-left">
                    <input type="text" class="form-control" disabled value="7">
                </div>
                <div class="form-group custom-textbox-left">
                    <input type="text" class="form-control" disabled value="6">
                </div>
                <div class="form-group custom-textbox-left">
                    <input type="text" class="form-control" disabled value="5">
                </div>
                <div class="form-group custom-textbox-left">
                    <input type="text" class="form-control" disabled value="4">
                </div>
                <div class="form-group custom-textbox-left">
                    <input type="text" class="form-control" disabled value="3">
                </div>
                <div class="form-group custom-textbox-left">
                    <input type="text" class="form-control" disabled value="2">
                </div>
                <div class="form-group custom-textbox-left">
                    <input type="text" class="form-control" disabled value="1">
                </div>
            </div>
            <div class="input-group col-1" style="border-bottom: 2px solid black;"> 
            </div>
            <div class="input-group col-4" style="border-bottom: 2px solid black;"> 
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" disabled value="1">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" disabled value="2">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" disabled value="3">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" disabled value="4">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" disabled value="5">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" disabled value="6">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" disabled value="7">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" disabled value="8">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-2" style="margin-top: 18px;">
                <label></label>
            </div>
            <div class="input-group col-5" style="border-right: 2px solid black;"> 
                <div class="form-group custom-textbox-left" style="margin-top: 18px;">
                    <input type="text" class="form-control" disabled value="8">
                </div>
                <div class="form-group custom-textbox-left" style="margin-top: 18px;">
                    <input type="text" class="form-control" disabled value="7">
                </div>
                <div class="form-group custom-textbox-left" style="margin-top: 18px;">
                    <input type="text" class="form-control" disabled value="6">
                </div>
                <div class="form-group custom-textbox-left" style="margin-top: 18px;">
                    <input type="text" class="form-control" disabled value="5">
                </div>
                <div class="form-group custom-textbox-left" style="margin-top: 18px;">
                    <input type="text" class="form-control" disabled value="4">
                </div>
                <div class="form-group custom-textbox-left" style="margin-top: 18px;">
                    <input type="text" class="form-control" disabled value="3">
                </div>
                <div class="form-group custom-textbox-left" style="margin-top: 18px;">
                    <input type="text" class="form-control" disabled value="2">
                </div>
                <div class="form-group custom-textbox-left" style="margin-top: 18px;">
                    <input type="text" class="form-control" disabled value="1">
                </div>
            </div>
            <div class="input-group col-1" style="margin-top: 18px;"> 
            </div>
            <div class="input-group col-4" style="margin-top: 18px;"> 
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" disabled value="1">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" disabled value="2">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" disabled value="3">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" disabled value="4">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" disabled value="5">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" disabled value="6">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" disabled value="7">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" disabled value="8">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="form-group col-2">
                <label></label>
            </div>
            <div class="input-group col-5" style="border-right: 2px solid black;"> 
                <div class="form-group custom-textbox-left">
                    <input type="text" class="form-control" id="teeth1BL" aria-describedby="action" v-model="patientOrthoSpace.teeth1BL">
                </div>
                <div class="form-group custom-textbox-left">
                    <input type="text" class="form-control" id="teeth2BL" aria-describedby="action" v-model="patientOrthoSpace.teeth2BL">
                </div>
                <div class="form-group custom-textbox-left">
                    <input type="text" class="form-control" id="teeth3BL" aria-describedby="action" v-model="patientOrthoSpace.teeth3BL">
                </div>
                <div class="form-group custom-textbox-left">
                    <input type="text" class="form-control" id="teeth4BL" aria-describedby="action" v-model="patientOrthoSpace.teeth4BL">
                </div>
                <div class="form-group custom-textbox-left">
                    <input type="text" class="form-control" id="teeth5BL" aria-describedby="action" v-model="patientOrthoSpace.teeth5BL">
                </div>
                <div class="form-group custom-textbox-left">
                    <input type="text" class="form-control" id="teeth6BL" aria-describedby="action" v-model="patientOrthoSpace.teeth6BL">
                </div>
                <div class="form-group custom-textbox-left">
                    <input type="text" class="form-control" id="teeth7BL" aria-describedby="action" v-model="patientOrthoSpace.teeth7BL">
                </div>
                <div class="form-group custom-textbox-left">
                    <input type="text" class="form-control" id="teeth8BL" aria-describedby="action" v-model="patientOrthoSpace.teeth8BL">
                </div>
            </div>
            <div class="form-group col-1">
                <label></label>
            </div>
            <div class="input-group col-4"> 
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" id="teeth1BR" aria-describedby="action" v-model="patientOrthoSpace.teeth1BR">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" id="teeth2BR" aria-describedby="action" v-model="patientOrthoSpace.teeth2BR">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" id="teeth3BR" aria-describedby="action" v-model="patientOrthoSpace.teeth3BR">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" id="teeth4BR" aria-describedby="action" v-model="patientOrthoSpace.teeth4BR">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" id="teeth5BR" aria-describedby="action" v-model="patientOrthoSpace.teeth5BR">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" id="teeth6BR" aria-describedby="action" v-model="patientOrthoSpace.teeth6BR">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" id="teeth7BR" aria-describedby="action" v-model="patientOrthoSpace.teeth7BR">
                </div>
                <div class="form-group custom-textbox-right">
                    <input type="text" class="form-control" id="teeth8BR" aria-describedby="action" v-model="patientOrthoSpace.teeth8BR">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="form-group col-2">
                <label>Mesiodistal</label>
            </div>
            <div class="form-group col-2">
                <input type="number" class="form-control" id="mesiodistal1BL" aria-describedby="action" v-model="patientOrthoSpace.mesiodistal1BL">
            </div>
            <div class="form-group col-2">
                <input type="number" class="form-control" id="mesiodistal2BL" aria-describedby="action" v-model="patientOrthoSpace.mesiodistal2BL">
            </div>
            <div class="input-group col-1" style="border-right: 2px solid black;"> 
            </div>
            <div class="input-group col-1"> 
            </div>
            <div class="form-group col-2">
                <input type="number" class="form-control" id="mesiodistal1BR" aria-describedby="action" v-model="patientOrthoSpace.mesiodistal1BR">
            </div>
            <div class="form-group col-2">
                <input type="number" class="form-control" id="mesiodistal2BR" aria-describedby="action" v-model="patientOrthoSpace.mesiodistal2BR">
            </div>
        </div>

        <div class="row">
            <div class="form-group col-2">
                <label>Panjang Lengkung</label>
            </div>
            <div class="form-group col-2">
                <input type="number" class="form-control" id="bendLength1BL" aria-describedby="action" v-model="patientOrthoSpace.bendLength1BL">
            </div>
            <div class="form-group col-2">
                <input type="number" class="form-control" id="bendLength2BL" aria-describedby="action" v-model="patientOrthoSpace.bendLength2BL">
            </div>
            <div class="input-group col-1" style="border-right: 2px solid black;"> 
            </div>
            <div class="input-group col-1"> 
            </div>
            <div class="form-group col-2">
                <input type="number" class="form-control" id="bendLength1BR" aria-describedby="action" v-model="patientOrthoSpace.bendLength1BR">
            </div>
            <div class="form-group col-2">
                <input type="number" class="form-control" id="bendLength2BR" aria-describedby="action" v-model="patientOrthoSpace.bendLength2BR">
            </div>
        </div>

        <div class="row">
            <div class="form-group col-2">
                <label>Jumlah Mesiodistal</label>
            </div>
            <div class="input-group col-2"> 
            </div>
            <div class="form-group col-2">
                <div class="input-group mb-2 mr-sm-2">
                    <input type="number" class="form-control" id="sumOfMesiodistalBL" v-model="patientOrthoSpace.sumOfMesiodistalBL">
                    <div class="input-group-prepend">
                        <div class="input-group-text">mm</div>
                    </div>
                </div>
            </div>
            <div class="input-group col-1" style="border-right: 2px solid black;"> 
            </div>
            <div class="input-group col-1"> 
            </div>
             <div class="form-group col-2">
                <div class="input-group mb-2 mr-sm-2">
                    <input type="number" class="form-control" id="sumOfMesiodistalBR" v-model="patientOrthoSpace.sumOfMesiodistalBR">
                    <div class="input-group-prepend">
                        <div class="input-group-text">mm</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="form-group col-2">
                <label>Panjang Lengkung</label>
            </div>
            <div class="input-group col-2"> 
            </div>
            <div class="form-group col-2">
                <div class="input-group mb-2 mr-sm-2">
                    <input type="number" class="form-control" id="bendLengthBL" v-model="patientOrthoSpace.bendLengthBL">
                    <div class="input-group-prepend">
                        <div class="input-group-text">mm</div>
                    </div>
                </div>
            </div>
            <div class="input-group col-1" style="border-right: 2px solid black;"> 
            </div>
            <div class="input-group col-1"> 
            </div>
             <div class="form-group col-2">
                <div class="input-group mb-2 mr-sm-2">
                    <input type="number" class="form-control" id="bendLengthBR" v-model="patientOrthoSpace.bendLengthBR">
                    <div class="input-group-prepend">
                        <div class="input-group-text">mm</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="form-group col-2">
                <label>Kekurangan tempat</label>
            </div>
            <div class="input-group col-2"> 
            </div>
            <div class="form-group col-2">
                <div class="input-group mb-2 mr-sm-2">
                    <input type="number" class="form-control" id="lackOfSpaceBL" v-model="patientOrthoSpace.lackOfSpaceBL">
                    <div class="input-group-prepend">
                        <div class="input-group-text">mm</div>
                    </div>
                </div>
            </div>
            <div class="input-group col-1" style="border-right: 2px solid black;"> 
            </div>
            <div class="input-group col-1"> 
            </div>
             <div class="form-group col-2">
                <div class="input-group mb-2 mr-sm-2">
                    <input type="number" class="form-control" id="lackOfSpaceBR" v-model="patientOrthoSpace.lackOfSpaceBR">
                    <div class="input-group-prepend">
                        <div class="input-group-text">mm</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="form-group col-2">
                <label>Pergeseran Median Line</label>
            </div>
            <div class="input-group col-2"> 
            </div>
            <div class="form-group col-2">
                <div class="input-group mb-2 mr-sm-2">
                    <input type="number" class="form-control" id="medianLineBL" v-model="patientOrthoSpace.medianLineBL">
                    <div class="input-group-prepend">
                        <div class="input-group-text">mm</div>
                    </div>
                </div>
            </div>
            <div class="input-group col-2"> 
            </div>
             <div class="form-group col-2">
                <div class="input-group mb-2 mr-sm-2">
                    <input type="number" class="form-control" id="medianLineBR" v-model="patientOrthoSpace.medianLineBR">
                    <div class="input-group-prepend">
                        <div class="input-group-text">mm</div>
                    </div>
                </div>
            </div>
        </div>
        <br />
        <div class="form-inline" id="centercontent">
            <label>RB</label>
            <div class="input-group mb-2 mr-sm-2">
                <input type="number" class="form-control" id="rb" v-model="patientOrthoSpace.rb">
                <div class="input-group-prepend">
                    <div class="input-group-text">mm</div>
                </div>
            </div>
        </div>
        <br /><br />

        <!-- <app-datatable :type="'input'" :newData="newDetail" :elements="dtElements" :collections="mm.mailManagementDetail"></app-datatable> -->
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-danger" @click="cancel"  style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { PatientOrthoSpace } from '../../models/patientOrthoSpace'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'

export default {
    components: {
        AppLookupField, AppDatatable, AppDatePicker, AppDropdown, AppNavBar
    },
    data() {
        return {
            patientOrthoSpace: {
                ...PatientOrthoSpace
            },
            patientLookup: {
                id: 'patient',
                title: 'Patient',
                type: 'form',
                apiUrl: 'patient-list',
                filter: ['name', 'address'],
                fields: [
                    {
                        placeholder: 'Patient',
                        width: 12,
                        column: 'patientName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Patient Name',
                        column: 'name'
                    },
                    {
                        title: 'Patient Date Of Birth',
                        column: 'dateOfBirth',
                        type: 'date',
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'patientId'
                    },
                    {
                        from: 'name',
                        to: 'patientName'
                    },
                    {
                        from: 'address',
                        to: 'patientAddress'
                    },
                    {
                        from: 'patientAge',
                        to: 'patientAge'
                    }
                ]
            },
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const patientOrthoSpaceApi = api('patient-ortho-space/detail')
            this.patientOrthoSpace = await patientOrthoSpaceApi.getWithParams(this.$route.query.id)
        }
    },
    methods: {
        async save() {
            const patientOrthoSpaceApi = api('patient-ortho-space')

            if(this.$route.query.id !== undefined) {
                await patientOrthoSpaceApi.update(this.patientOrthoSpace, this.$route.query.id)
            } else {
                await patientOrthoSpaceApi.create(this.patientOrthoSpace)
            }
            // this.$router.push({ name: 'patientOrthoSpace' })
            this.$router.go(-1)
        },
        cancel() {
            // this.$router.push({ name: 'patientOrthoSpace' })
            this.$router.go(-1)
        },
        finishLookup(data) {
            const currentPatientOrthoSpace = this.patientOrthoSpace
            this.patientOrthoSpace = {
                ...currentPatientOrthoSpace,
                ...data
            }
        },
        selectChange(data) {
            const currentPatientOrthoSpace = this.patientOrthoSpace
            this.patientOrthoSpace = {
                ...currentPatientOrthoSpace,
                ...data
            }
        },
    }
}
</script>